// Aliases are deliberately explicit: custom questions with similar names may differ.
const ALIASES = {
    Email: 'email',
    'First name': 'first_name',
    'Last name': 'last_name',
    'Phone number': 'phone_number',
    lead_id: 'tiktok_lead_id',
    form_id: 'tiktok_form_id',
    created_time: 'tiktok_lead_created_time',
};

const LABELS = {
    email: 'Email', first_name: 'First name', last_name: 'Last name', phone_number: 'Phone number',
    tiktok_lead_id: 'TikTok lead ID', tiktok_form_id: 'TikTok form ID',
    tiktok_advertiser_id: 'TikTok advertiser ID', tiktok_lead_created_time: 'Created time',
    campaign_id: 'Campaign ID', campaign_name: 'Campaign name',
    ad_id: 'Ad ID', ad_name: 'Ad name', adgroup_id: 'Ad group ID', adgroup_name: 'Ad group name',
};

const TRACKING_KEYS = new Set([
    'tiktok_lead_id', 'tiktok_form_id', 'tiktok_advertiser_id', 'advertiser_id',
    'tiktok_lead_created_time', 'create_time', 'form_name',
    'campaign_id', 'campaign_name', 'ad_id', 'ad_name', 'adgroup_id', 'adgroup_name',
]);

function displayValue(value) {
    if (value == null) return '—';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
}

function displayLabel(key) {
    if (Object.prototype.hasOwnProperty.call(LABELS, key)) return LABELS[key];
    if (key.startsWith('utm_')) return `UTM ${key.slice(4).replaceAll('_', ' ')}`;
    const words = key.replaceAll('_', ' ');
    return words.charAt(0).toUpperCase() + words.slice(1);
}

export function getTikTokMetadataSections(leadMetadata, sourceMetadata) {
    const entries = [
        ...(Array.isArray(leadMetadata) ? leadMetadata : []).map((entry) => ({
            rawKey: entry?.key ?? '', value: entry?.value, origin: 'Form answers',
        })),
        ...Object.entries(sourceMetadata ?? {}).map(([rawKey, value]) => ({ rawKey, value, origin: 'Source metadata' })),
    ];
    const uniqueEntries = [];
    const seen = new Set();
    entries.forEach((entry) => {
        const key = Object.prototype.hasOwnProperty.call(ALIASES, entry.rawKey) ? ALIASES[entry.rawKey] : entry.rawKey;
        const identity = JSON.stringify([key, typeof entry.value, entry.value]);
        if (seen.has(identity)) return;
        seen.add(identity);
        uniqueEntries.push({ ...entry, canonicalKey: key, key: displayLabel(key), value: displayValue(entry.value) });
    });
    const counts = new Map();
    uniqueEntries.forEach(({ canonicalKey }) => counts.set(canonicalKey, (counts.get(canonicalKey) || 0) + 1));
    const sections = [
        { title: 'Form answers', entries: [] },
        { title: 'Tracking details', entries: [] },
    ];
    uniqueEntries.forEach((entry) => {
        const tracking = TRACKING_KEYS.has(entry.canonicalKey) || entry.canonicalKey.startsWith('utm_');
        sections[tracking ? 1 : 0].entries.push({
            ...entry,
            originLabel: counts.get(entry.canonicalKey) > 1 ? `${entry.origin} · ${entry.rawKey}` : null,
        });
    });
    return sections;
}
